export default __webpack_public_path__ + "781dcfa31a77c2a347f5f8e73c1c1df8.svg";